import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"

import { PRODUCTS_REVIEW_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { clearProductsReviewSignals } from "./@signals"
import { useProductsReview } from "./@hooks"
import ProductsReviewFilters from "./Filters"
import ProductsReviewTable from "./Table"
import StatsCards from "./StatsCards"
import TruncationAlert from "./TruncationAlert"


export default function ProductsReviewPage() {
    // Initialize hook to handle data fetching
    useProductsReview()

    useEffect(() => {
        return clearProductsReviewSignals
    }, [])

    return <PageWrapper
        head={PRODUCTS_REVIEW_ROUTES.TITLE}
        title={PRODUCTS_REVIEW_ROUTES.TITLE}
        subtitle={PRODUCTS_REVIEW_ROUTES.SUBTITLE}
        actions={null}
    >
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <ProductsReviewFilters />
            </Grid>

            <Grid item xs={12}>
                <TruncationAlert />
                <StatsCards />
                <ProductsReviewTable />
            </Grid>
        </Grid>
    </PageWrapper>
}
